import { ReactElement } from 'react';

import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { InteractiveTable } from '@dreryk/react-components';

import { healthcareLocationSearchCreator } from '~legacy.healthcare-provider';

import { doctorsMappingsTranslationKeys } from '../../../../translations';

import { HealthcareProviderLocationSelectCellItem } from './HealthcareProviderLocationSelectCellItem';

type HealthcareProviderLocationSelectProps = {
   readonly index: number;
   readonly defaultValue?: HealthcareProviderLocation;
};

type HealthcareProviderLocationListProps = {
   readonly items: HealthcareProviderLocation[];
};

const keyExtractor = (location: HealthcareProviderLocation): number => location.locationIdentifier.locationId;

const HealthcareProviderLocationList = (props: HealthcareProviderLocationListProps): ReactElement => (
   <InteractiveTable.SelectCell.List<HealthcareProviderLocation> items={props.items} keyExtractor={keyExtractor}>
      {(location) => {
         return (
            <HealthcareProviderLocationSelectCellItem
               item={location}
               testId={location.locationIdentifier.locationId}
               facilityName={location.name}
               facilityAddress={location.address}
            />
         );
      }}
   </InteractiveTable.SelectCell.List>
);

const triggerLabelExtractor = (location?: HealthcareProviderLocation): string => location?.name ?? '';

export const HealthcareProviderLocationSelectCell = (props: HealthcareProviderLocationSelectProps): ReactElement => {
   return (
      <InteractiveTable.SelectCell<HealthcareProviderLocation>
         testId={'healthcareProviderLocation'}
         triggerLabelExtractor={triggerLabelExtractor}
         name={'healthcareProviderLocation'}
         index={props.index}
         defaultValue={props.defaultValue ?? null}
         placeholder={doctorsMappingsTranslationKeys.choose}
         showClearIcon
      >
         <InteractiveTable.SelectCell.SearchCreator<HealthcareProviderLocation>
            searchCreator={healthcareLocationSearchCreator}
         >
            {({ items: locations }) => <HealthcareProviderLocationList items={locations} />}
         </InteractiveTable.SelectCell.SearchCreator>
      </InteractiveTable.SelectCell>
   );
};
